// entry-passage-colors.ts
export const CURRENT_PALETTE = [
    'rgba(255, 205, 86, 1)', // jaune de base — entrée 1
    'rgba(203, 143, 0, 1)', // ambre clair — entrée 2
    'rgba(160, 105, 0, 1)', // ambre foncé — entrée 3
    'rgba(245, 200, 100, 1)', // ambre très clair — entrée 4
];

export const VERSUS_PALETTE = [
    'rgba(74, 131, 139, 1)', // bleu de base — entrée 1
    'rgba(2, 79, 93, 1)', // #024f5d teal foncé — entrée 2
    'rgba(41, 128, 185, 1)', // bleu moyen — entrée 3
    'rgba(10, 40, 60, 1)', // bleu marine très foncé — entrée 4
];

export function getColor(palette: string[], index: number): string {
    return palette[index % palette.length];
}
